import { mainSiteUrl } from '@/mocks/categories';

export default function CTASection() {
  return (
    <section className="py-16 md:py-24 px-6 md:px-10 bg-background-50">
      <div className="max-w-5xl mx-auto">
        <div className="rounded-2xl overflow-hidden aspect-[21/9] mb-10 relative">
          <img
            src="https://readdy.ai/api/search-image?query=Vibrant%20overhead%20flat%20lay%20composition%20of%20diverse%20fashion%20and%20lifestyle%20products%20including%20colorful%20sneakers%20a%20pastel%20hoodie%20a%20leather%20crossbody%20bag%20sunglasses%20and%20a%20notebook%20arranged%20in%20an%20artistic%20sunburst%20pattern%20on%20a%20warm%20terracotta%20textured%20surface%2C%20bright%20cheerful%20natural%20lighting%20from%20above%2C%20editorial%20product%20photography%2C%20playful%20energetic%20aesthetic%20with%20pops%20of%20coral%20orange%20mint%20green%20and%20golden%20yellow%2C%20stylish%20modern%20composition%20with%20lots%20of%20visual%20variety&width=1800&height=770&seq=cta-bg-litbuy-v2&orientation=landscape"
            alt="LitBuy Spreadsheet Product Collection"
            title="LitBuy Spreadsheet - Shop Smart with Organized Categories"
            className="w-full h-full object-cover object-top"
            loading="lazy"
          />
        </div>

        <div className="text-center max-w-2xl mx-auto">
          <p className="font-heading text-2xl md:text-4xl font-bold text-foreground-900 leading-snug">
            Ready to <span className="italic font-normal text-foreground-600">transform</span> your 
            shopping experience with a <span className="italic font-normal text-foreground-600">LitBuy spreadsheet</span>?
          </p>
          <p className="mt-4 text-sm md:text-base text-foreground-600">
            Browse thousands of organized product listings across all categories. 
            Find the best deals, compare prices, and shop with confidence.
          </p>
          <div className="flex flex-col sm:flex-row items-center justify-center gap-3 mt-8">
            <a
              href={mainSiteUrl}
              target="_blank"
              rel="noopener nofollow"
              className="inline-flex items-center px-6 py-3 rounded-full bg-foreground-900 text-background-50 text-sm font-medium hover:bg-foreground-800 transition-colors whitespace-nowrap cursor-pointer"
            >
              LitBuy Spreadsheet
              <span className="w-4 h-4 flex items-center justify-center ml-2">
                <i className="ri-arrow-right-up-line text-sm"></i>
              </span>
            </a>
            <a
              href={mainSiteUrl}
              target="_blank"
              rel="noopener nofollow"
              className="inline-flex items-center px-6 py-3 rounded-full border border-foreground-300/60 text-foreground-900 text-sm font-medium hover:bg-foreground-50 transition-colors whitespace-nowrap cursor-pointer"
            >
              Buy It Now
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}